// extracted by mini-css-extract-plugin
module.exports = {"root":"ValidationError_root__1SXA9","iconError":"ValidationError_iconError__1pcDU","errorText":"ValidationError_errorText__3FeJ_"};